import React from 'react'
import { Button } from '@mantine/core'
import { Icon } from '@/components/Icon'
import { ellipsis } from '@/utils'
import { useGlobalLayout } from '../GlobalLayoutProvider'
import { useNavigationMobileMenu } from './NavigationMobileMenuProvider'
import { useChain } from '@cosmos-kit/react'

const NavigationMobileMenuConnectWallet: React.FC = () => {
  const { address, connect, status } = useChain('stride')

  const { openConnectWalletDropdown } = useGlobalLayout()
  const { close } = useNavigationMobileMenu()

  const isConnecting = status === 'Connecting'

  const handleConnect = () => {
    connect()
    close()
  }

  const handleClick = () => {
    openConnectWalletDropdown()
    close()
  }

  if (address) {
    return (
      <Button
        fullWidth
        leftIcon={<Icon name="wallet" />}
        color="dark"
        sx={{ background: '#373A40' }}
        loading={isConnecting}
        onClick={handleClick}>
        {ellipsis(address, 20)}
      </Button>
    )
  }

  return (
    <Button fullWidth onClick={handleConnect} leftIcon={<Icon name="wallet" />} loading={isConnecting}>
      Connect wallet
    </Button>
  )
}

export { NavigationMobileMenuConnectWallet }
